import { UAParser } from 'ua-parser-js'
import * as QueryString from 'query-string'
import Config from '../config/vue.config'

// 対象となるアクセスの場合はquery stringで指定されたadust tracker urlへリダイレクトする
export const redirectToTrackerURLIfNeeded = (
  ua: string = window.navigator.userAgent,
  location: Location = window.location
) => {
  if (!isTarget(ua, location.search)) return

  const tracker = trackerURL(location.search, location.pathname)
  if (!tracker) return
  location.href = tracker
}

export const generateTrackerURL = (
  tracker: string,
  pathname: string
): string | undefined => {
  const BASE_URL = 'https://app.adjust.com'
  return `${BASE_URL}/${tracker}?deep_link=${encodeURIComponent(
    adjustDeeplinkUri(pathname)
  )}&deeplink_js=1`
}

const isTarget = (ua: string, queryString: string): boolean => {
  // アプリ内WebViewでの表示時はリダイレクト対象から除外する
  const params = QueryString.parse(queryString)
  const vliveClientParam = params.vlive_client
  if (vliveClientParam) return false

  // Android/iOSからのアクセスのみを対象とする
  const os = new UAParser(ua).getOS().name || ''
  return ['Android', 'iOS'].includes(os)
}

const trackerURL = (
  queryString: string,
  pathname: string
): string | undefined => {
  const params = QueryString.parse(queryString)
  const tracker = params.adj_t
  if (typeof tracker !== 'string' || tracker.length < 1) return

  return generateTrackerURL(tracker, pathname)
}

// adjust経由でもdeeplinkが動作するように、現在のurlのpathからdeep_linkパラメタを生成
const adjustDeeplinkUri = (locationPathname: string): string => {
  let path = locationPathname
  if (path.startsWith('/')) {
    // pathの先頭の `/` は不要なので削る
    path = path.substring(1)
  }
  return `${Config.customUrlScheme}${path}`
}

export function redirectToCustomURLSchemeForAppOpen() {
  // アプリがインストールされていない場合は従来通りダウンロード案内ページへ飛ばす
  window.location.href = Config.customUrlScheme

  // この時、裏側では必ずダウンロード案内ページが開いてしまうが許容する
  setTimeout(function () {
    window.location.href = '/download'
  }, 1000)
}
